import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "mb-1"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

import { computed } from 'vue';
import { SampleType } from '@/gql/graphql';
import { BBadge, BModal, BTooltip } from 'bootstrap-vue-next';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'SampleDetail',
  props: {
    show: { type: Boolean },
    sample: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

const show = computed<boolean>(() => {
  return props.show;
});

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "flask",
          class: "me-2"
        }),
        _createElementVNode("strong", null, _toDisplayString(__props.sample?.name), 1),
        _cache[1] || (_cache[1] = _createTextVNode(" sample details ", -1))
      ]),
      default: _withCtx(() => [
        (__props.sample)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "tag",
                  class: "me-2"
                }),
                _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Name: ", -1)),
                _createTextVNode(" " + _toDisplayString(__props.sample.name), 1)
              ]),
              (__props.sample.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "info-circle",
                      class: "me-2"
                    }),
                    _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Description: ", -1)),
                    _createTextVNode(" " + _toDisplayString(__props.sample.description), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "file-lines",
                  class: "me-2"
                }),
                _cache[4] || (_cache[4] = _createElementVNode("strong", null, "File R1: ", -1)),
                _createTextVNode(" " + _toDisplayString(__props.sample.fileR1), 1)
              ]),
              _createElementVNode("p", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "file-lines",
                  class: "me-2"
                }),
                _cache[5] || (_cache[5] = _createElementVNode("strong", null, "File R2: ", -1)),
                _createTextVNode(" " + _toDisplayString(__props.sample.fileR2), 1)
              ]),
              _createElementVNode("p", _hoisted_6, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fas fa-cube",
                  class: "me-2"
                }),
                _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Kit: ", -1)),
                (__props.sample.kit)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(__props.sample.kit.name) + " ", 1),
                      (__props.sample.kit.description)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            id: "kit-desc-icon",
                            icon: "circle-info"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(BTooltip), { target: "kit-desc-icon" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.sample.kit.description), 1)
                        ]),
                        _: 1
                      }),
                      (__props.sample.kit.code?.code)
                        ? (_openBlock(), _createBlock(_unref(BBadge), {
                            key: 1,
                            variant: "warning",
                            class: "ms-1",
                            id: "kit-code-badge"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "barcode",
                                class: "me-2"
                              }),
                              _createTextVNode(" " + _toDisplayString(__props.sample.kit.code.code), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(BTooltip), { target: "kit-code-badge" }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("kit code", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(BBadge), {
                        variant: "success",
                        class: "ms-1",
                        id: "kit-version-badge"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "v",
                            class: "me-2"
                          }),
                          _createTextVNode(" " + _toDisplayString(__props.sample.kit.version ? __props.sample.kit.version : 'not specified'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(BTooltip), { target: "kit-version-badge" }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("version", -1)
                        ]))]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" unspecified")
                    ], 64))
              ]),
              (__props.sample.kit)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "barcode",
                      class: "me-2"
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Barcode: ", -1)),
                    (__props.sample.kit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.sample.kit.barcode), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, " unspecified"))
                  ]))
                : _createCommentVNode("", true),
              (__props.sample.kit)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "hashtag",
                      class: "me-2"
                    }),
                    _cache[10] || (_cache[10] = _createElementVNode("strong", null, "UMI length: ", -1)),
                    (__props.sample.kit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(__props.sample.kit.umiLength), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, " unspecified"))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})